export default {"src":"/_next/static/image/public/images/flags/flag_1670.8b2766afeab0941f5ab7f5149fd71c8c.svg","height":16,"width":24};